// Implements: F-PRV-008
/**
 * Switches for what the viewer offers.
 *
 * W3e wired `DownloadVersionFrame` at `/api/mockups/{m}/preview/{v}/document.html`, so the download
 * control is on; the file name comes from the server's `Content-Disposition`.
 */
const DOWNLOAD_ROUTE_WIRED = true;

export function previewDownloadAvailable(): boolean {
  return DOWNLOAD_ROUTE_WIRED;
}
